import React from 'react';
import { CircleButton, LinkText } from '../../index';
import './LinkCTA.scss';

export const LinkCTA = ({
    children,
    className,
    disabled,
    icon,
    ...linkProps
}) => {

    const linkCTAClasses = [
        `bsw-link-cta`,
        `${disabled ? 'bsw-link-cta--disabled' : ''}`,
        `${className ? className : ''}`,
    ].join(' ');

    return (
        <div className={linkCTAClasses}>
            <LinkText
                {...linkProps}
                disabled={disabled}
                typographyType={linkProps.typographyType ? linkProps.typographyType : "body-02"}
            >
                {children} 
                <CircleButton icon={icon ? icon : "arrow"} colorStyle="float" as={'div'} disabled={disabled} />
            </LinkText>
        </div>
    );
};
